module.exports = __webpack_public_path__ + "static/media/scratch-off-track-and-trace-combo.8704254e.svg";